// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__nwcTk","fade":"List_fade__3mfbH","fadeIn":"List_fadeIn__ImINr","scaleXin":"List_scaleXin__tfp3a"};